import { Component, OnInit, Inject, Output, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';

import { CommonService, AlertService, AdminService } from '../../../_services/';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.scss']
})
export class EditUserDialogComponent implements OnInit {
  editUserForm:FormGroup;
  submitted = false;
  errMsg:String = '';
  showSources:Boolean=false;
  showJobFunction:Boolean = false;
  showNickname:Boolean = false;
  showTDActive = false;
  userData:any;
  contactTypes:any=[];
  contactSources:any=[];
  jobFunctionList:any=[];
  showroomList:any=[];
  checkedShowrooms:string[];
  checkedJobFunctions:string[];
  private subscription: Subscription;
  private subscription2: Subscription;

  constructor(
    public dialogRef: MatDialogRef<EditUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService
  ) { }

  ngOnInit() {
    this.userData = this.data.userData;

    this.checkedShowrooms = this.userData.payload.data().showroom.map(item => item.showroom_id);
    this.checkedJobFunctions = this.userData.payload.data().job_functions;
    this.jobFunctionList = this.data.jobFunctionList;
    this.showroomList = this.data.showroomList.map(item=>{ 
      this.checkedShowrooms.indexOf(item.id)>-1?item.selected=true:'';
      return item;
    });
    this.jobFunctionList = this.data.jobFunctionList.map(item=>{ 
      this.checkedJobFunctions.indexOf(item.id)>-1?item.selected=true:'';
      return item;
    });
    
    this.editUserForm = this.fb.group({
      first_name: [null, [Validators.required,  Validators.minLength(3), Validators.maxLength(50)]],
      last_name: [null, [Validators.required, Validators.minLength (3), Validators.maxLength(50)]],
      email: [{value: null, disabled: true}, [Validators.required, Validators.email, Validators.maxLength(200)]],
      password: [null, [Validators.minLength (6)]],
      contact_type_id: ['', [Validators.required]],
      nickname: [null, [ Validators.maxLength(50)]],
      contact_source:['', []],
      is_technical_designer : ['', []],
      is_technical_designer_active : ['', []],
      job_functions: this.buildJobFunctions(),
      showrooms: this.buildShowrooms(),
    })
    
    // this.getUserDetail(this.data.id);
    this.getContactTypeList();
    this.getContactSourceList();
    // update data into edit form...
    this.editUserForm.patchValue({
      first_name : this.userData.payload.data().first_name,
      last_name : this.userData.payload.data().last_name,
      email : this.userData.payload.data().email,
      contact_type_id: this.userData.payload.data().contact_type_id,
      contact_source: this.userData.payload.data().source,
      nickname : this.userData.payload.data().nickname,
      is_technical_designer: this.userData.payload.data().is_technical_designer == true ? "1" : "0",
      is_technical_designer_active: this.userData.payload.data().is_technical_designer_active == true? 1: 0,
    })
    if(this.userData.payload.data().is_technical_designer == true){
      this.showTDActive = true;
    }
    if(this.userData.payload.data().contact_type_id==="staff"){
      this.showJobFunction = true;
    }
    else if(this.userData.payload.data().contact_type_id==="lead"){
      
      this.showSources = true;
    }
    else if (this.userData.payload.data().contact_type_id==="device"){
      this.showNickname = true;
    }
  }


  showHideFields(event){
    this.showJobFunction = false;
    this.showSources = false;
    this.showNickname = false;
    if(event.target.value==="staff"){
      this.showJobFunction = true;
    }
    else if(event.target.value==="lead"){
      
      this.showSources = true;
    }
    else if (event.target.value==="device"){
      this.showNickname = true;
    }
  }

  handleRadioChange(event) {
    if(this.editUserForm.value.is_technical_designer==1){
      this.showTDActive = true;
    }
    else {
      this.showTDActive = false;
    }
    
  }
  
  hideEditUserDialog(){
    this.dialogRef.close();
  }

  get fval() {
    return this.editUserForm.controls;
  }

  buildJobFunctions() {
    
    const arr = this.jobFunctionList.map((item) => {
      return this.fb.control(item.selected);
    }); 
    return this.fb.array(arr); 
  }

  buildShowrooms() {
    const arr = this.showroomList.map((item) => {
      return this.fb.control(item.selected);
    }); 
    return this.fb.array(arr); 
  }

  get showrooms() {
    return this.editUserForm.get('showrooms') as FormArray;
  };
  
  get job_functions() {
    return this.editUserForm.get('job_functions') as FormArray;
  };


  getContactTypeList(){
    this.subscription =this._admin.getContactTypeList().subscribe(result=>{
      this.contactTypes = result;
    },err=>{
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  getContactSourceList(){
    // this._common.showLoader(true);
    this.subscription2 = this._admin.getContactSourceList().subscribe(result=>{
      // this._common.showLoader(false);
      this.contactSources = result;
    },err=>{
      // this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }  
/*
  getUserDetail(id){
    this._common.showLoader(true);
    this._admin.getUserDetail(id).subscribe(res=>{
      this._common.showLoader(false);
      this.userData = res;
      console.log(this.userData.payload.data(),'data from server----');
      this.checkedShowrooms = this.userData.payload.data().showroom;
      
      this.editUserForm.patchValue({ 
        first_name : this.userData.payload.data().first_name,
        last_name : this.userData.payload.data().last_name,
        email : this.userData.payload.data().email,
        contact_type_id: this.userData.payload.data().contact_type_id,
        contact_source: this.userData.payload.data().source
      })
      if(this.userData.payload.data().contact_type_id==="staff"){
        this.showJobFunction = true;
      }
      else if(this.userData.payload.data().contact_type_id==="lead"){
        
        this.showSources = true;
      }
      else if (this.userData.payload.data().contact_type_id==="device"){
        this.showNickname = true;
      }
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }
*/
  onFormSubmit() {
    this.submitted = true;
    if (this.editUserForm.invalid) {
      return;
    } 
    let form = this.editUserForm.value;
    form.uid = localStorage.getItem('uid');
    
    this._common.showLoader(true);

    const f = Object.assign({}, form, {
      showrooms: form.showrooms.map((s, i) => {
      return {
        name: this.showroomList[i].name,
        id: this.showroomList[i].id,
        selected: s
      }
    }),
    job_functions: form.job_functions.map((s, i) => {
      return {
        name: this.jobFunctionList[i].name,
        id: this.jobFunctionList[i].id,
        selected: s
      }
    })
    })
       // showroom data manipulation
       let oldShowrooms = f.showrooms.filter(doc=>{ if(doc.selected==true){ return doc}})
      //  console.log(oldShowrooms,'old showrooms');
       form.showroom = [];
       for(let i = 0; i < oldShowrooms.length; i++) {
         form.showroom.push({"showroom_id": oldShowrooms[i].id});
       }
        // job function data manipulation
      let oldJobFunctions = f.job_functions.filter(doc=>{ if(doc.selected==true){ return doc}})
      form.job_functions = [];
      for(let i = 0; i < oldJobFunctions.length; i++) {
        form.job_functions.push(oldJobFunctions[i].id);
      }
      
    let data:any ={
      first_name : this.editUserForm.value.first_name,
      last_name : this.editUserForm.value.last_name,
      contact_type_id : this.editUserForm.value.contact_type_id,
      job_functions : form.job_functions,
      showroom : form.showroom,
      is_technical_designer : this.editUserForm.value.is_technical_designer == 1 ? true : false,
      is_technical_designer_active : this.editUserForm.value.is_technical_designer == 1 ? this.editUserForm.value.is_technical_designer_active == 1 ? true:false  : false,
    }
    if(this.editUserForm.value.contact_source){
      data.contact_source = this.editUserForm.value.contact_source;
    }
    if(this.editUserForm.value.nickname){
      data.nickname = this.editUserForm.value.nickname
    }
    this.hideEditUserDialog();
    // Edit data in users collection
    let user1Obj = {
      first_name : this.editUserForm.value.first_name,
      last_name : this.editUserForm.value.last_name,
      date_updated : new Date().getTime()
    }
    this._admin.editUser1(user1Obj, this.data.id).then(res=>{
      // Edit data in contacts collection
      this._admin.editUser(data,this.data.id).then(res => {
        this._common.showLoader(false);
        this.hideEditUserDialog();
        this._alert.success("User edited successfully!");
      },err=>{
        this._common.showLoader(false);
        this.errMsg = "Something went wrong"
      })  
    }, err =>{
      this._common.showLoader(false);
      this.errMsg = "Something went wrong"      
    })


  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
  }

}